import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["endpoint"];
import { CONTACTS, CURRENCY, FEATURES_DEFAULTS, FEATURE_INTEREST, HSFS_APPLICATION_STATUS, IDENTIFICATION_TOKEN, LIMIT_USAGE, MARKETING_CONTACTS_RENEWAL, MARKETING_CONTACTS_SWITCH, PHONE_NUMBER, PRODUCT, PRODUCT_INVENTORY, PROMOTIONS, PURCHASE_MOTIONS, REQUIRED_ONBOARDING, RETAIL, SEATS_INVENTORY } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import quickFetch from 'quick-fetch';
import { laboratoryClient } from '../utils/laboratoryClient';
const makeEarlyRequest = (name, _ref) => {
  let {
      endpoint
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  return quickFetch.makeEarlyRequest(name, Object.assign({
    url: quickFetch.getApiUrl(endpoint),
    type: 'GET',
    dataType: 'json',
    withCredentials: true,
    timeout: 12000
  }, options));
};
(function () {
  quickFetch.afterAuth(resp => {
    var _authData$user;
    const authData = resp;
    const portalId = quickFetch.getPortalId();
    makeEarlyRequest(PURCHASE_MOTIONS, {
      endpoint: `/monetization/v3/purchase-motions?portalId=${portalId}&location=MERCH_CARD&location=CALCULATOR`
    });

    // We include hostname b/c this request is cached. If we switch langs, we'll get a mismatched 'Access-Control-Allow-Origin'
    // which will cause an error, so we want to make sure switching domains doesnt read from the cache
    makeEarlyRequest(PRODUCT, {
      endpoint: `/monetization/v3/product/in-app?host=${window.location.hostname}`
    });
    makeEarlyRequest(PROMOTIONS, {
      endpoint: '/fintech-discounts/v4/promotions'
    });
    makeEarlyRequest(PRODUCT_INVENTORY, {
      endpoint: `/monetization/v3/product/inventory?portalId=${portalId}`
    });
    makeEarlyRequest(SEATS_INVENTORY, {
      endpoint: '/monetization/v3/seats/inventory'
    });
    makeEarlyRequest(HSFS_APPLICATION_STATUS, {
      endpoint: '/hsfx/v1/eligibility/status'
    });
    makeEarlyRequest(REQUIRED_ONBOARDING, {
      endpoint: '/eligibility-engine/v4/onboarding',
      type: 'POST',
      data: JSON.stringify({})
    });
    makeEarlyRequest(RETAIL, {
      endpoint: '/eligibility-engine/v2/retail'
    });
    let preferredLanguage = getPreferredLanguage();
    let phoneNumberUrl = '/monetization/v3/phone-numbers/in-app';
    if (preferredLanguage) {
      if (Array.isArray(preferredLanguage)) {
        preferredLanguage = preferredLanguage[0];
      }
      phoneNumberUrl = `${phoneNumberUrl}/${preferredLanguage.toLowerCase()}`;
    }
    makeEarlyRequest(PHONE_NUMBER, {
      endpoint: phoneNumberUrl
    });
    const contactData = {
      filterGroups: [],
      count: 0,
      sorts: []
    };
    makeEarlyRequest(CONTACTS, {
      endpoint: '/contacts/search/v1/search/contacts',
      timeout: 15000,
      contentType: 'application/json',
      type: 'POST',
      data: JSON.stringify(contactData)
    });

    // @ts-expect-error mock is only set in unit tests
    if (!quickFetch.mockRequests) {
      laboratoryClient.resolve();
    }

    // These filters should stay consistent with ELIGIBLE_AFTER_RENEWAL_FILTERS in marketable-contacts-client/constants/Filters.js
    const marketingContactsOnMCRenewalData = {
      portalId,
      objectTypeId: 'CONTACT',
      count: 0,
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: 'hs_marketable_status',
          values: ['true']
        }, {
          operator: 'IN',
          property: 'hs_marketable_until_renewal',
          values: ['false']
        }]
      }, {
        filters: [{
          operator: 'NOT_HAS_PROPERTY',
          property: 'hs_marketable_status'
        }, {
          operator: 'IN',
          property: 'hs_marketable_until_renewal',
          values: ['false']
        }]
      }, {
        filters: [{
          operator: 'NOT_HAS_PROPERTY',
          property: 'hs_marketable_until_renewal'
        }]
      }]
    };

    // These filters should stay consistent with ELIGIBLE_AFTER_SWITCH_TO_MC_FILTERS in marketable-contacts-client/constants/Filters.js
    const marketingContactsOnSwitchToMCData = {
      portalId,
      objectTypeId: 'CONTACT',
      count: 0,
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: 'hs_marketable_until_renewal',
          values: ['false']
        }]
      }, {
        filters: [{
          operator: 'NOT_HAS_PROPERTY',
          property: 'hs_marketable_until_renewal'
        }]
      }]
    };
    makeEarlyRequest(MARKETING_CONTACTS_RENEWAL, {
      endpoint: '/crm-search/search',
      type: 'POST',
      data: JSON.stringify(marketingContactsOnMCRenewalData)
    });
    makeEarlyRequest(MARKETING_CONTACTS_SWITCH, {
      endpoint: '/crm-search/search',
      type: 'POST',
      data: JSON.stringify(marketingContactsOnSwitchToMCData)
    });
    makeEarlyRequest(LIMIT_USAGE, {
      endpoint: '/feature/store/v1/usage?upgradeApiName=crm-suite-starter-bundle'
    });
    makeEarlyRequest(FEATURE_INTEREST, {
      endpoint: `/upgrade-management-service/v1/calculated-features/translated?productLevel=STARTER`
    });
    makeEarlyRequest(IDENTIFICATION_TOKEN, {
      endpoint: '/helpdesk-integration/v1/messages/tokens/create',
      type: 'POST'
    });
    const i18nLangLocale = (authData === null || authData === void 0 || (_authData$user = authData.user) === null || _authData$user === void 0 ? void 0 : _authData$user.locale) || 'en-us';
    const featuresDefaultsUrl = `/feature/store/v1/features/defaults/${i18nLangLocale}`;
    makeEarlyRequest(FEATURES_DEFAULTS, {
      endpoint: featuresDefaultsUrl
    });
    makeEarlyRequest(CURRENCY, {
      endpoint: '/monetization/v3/currency',
      type: 'GET'
    });
  });
})();